import {Component, Inject, Input, input, OnInit, output, ChangeDetectionStrategy} from '@angular/core';

import {Exam} from '@app/api/models/exam';

import {DATE_FORMAT, TIME_FORMAT} from '@app/api/constants';
import {DatePipe} from '@angular/common';
import {WaBadgeDirective, WaButtonDirective, WaCardDirective, WaIconDirective, WaTagDirective} from "angular-awesome";

@Component({
    selector: 'app-exam-list-element',
    templateUrl: './exam-list-element.component.html',
    styleUrls: ['./exam-list-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePipe, WaCardDirective, WaIconDirective, WaBadgeDirective, WaButtonDirective, WaTagDirective]
})
export class ExamListElementComponent implements OnInit {

  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() exam!: Exam;
  readonly selected = input<boolean>(false);
  readonly showControls = input<boolean>(false);

  editSupervisions = output<Exam>();
  editCorrections = output<Exam>();
  resetExam = output<Exam>();

  locationNames = new Set<string>();

  constructor(@Inject(DATE_FORMAT) public dateFormat: string,
              @Inject(TIME_FORMAT) public timeFormat: string) {}

  has_retake() {
    return !!this.exam.has_repetition;
  }

  ngOnInit(): void {
    this.exam.rooms.forEach(room => {
      this.locationNames.add(room.location.name);
    });
  }
}
